'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOembedUrl = exports.videoRegex = exports.client = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _domains = require('./domains');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = exports.client = _axios2.default.create({
  baseURL: 'https://iframely.blackbaud.services'
});

var videoRegex = exports.videoRegex = new RegExp('https?:\\/\\/(' + _domains.allowedVideoDomains + ')\\S*', 'i');

var getParentDomain = function getParentDomain() {
  if (typeof window !== 'undefined') {
    var hostname = window.location.hostname;

    return hostname === 'localhost' ? undefined : hostname;
  }

  return undefined;
};

var fetchOembedUrl = exports.fetchOembedUrl = function fetchOembedUrl(url) {
  return client.get('/iframely', {
    params: {
      url: url,
      iframe: 1,
      oembed: 1,
      _parent: getParentDomain()
    }
  }).then(function (response) {
    return response.data;
  }).then(function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _extends({}, data.oembed, data);
  }).then(function (data) {
    return data.error ? Promise.reject(data.error) : data;
  });
};

exports.default = fetchOembedUrl;